import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import welcomeReducer from '../features/welcome/welcome-reducer';
import loginReducer from '../features/login/login-slice';
import appConfigReducer from '../features/app-config/app-config-slice';
import registerReducer from '../features/register/register-slice';

const store = configureStore({
    reducer: {
        welcome: welcomeReducer,
        appConfigs: appConfigReducer,
        login: loginReducer,
        register: registerReducer,
    },
});

export type IAppDispatch = typeof store.dispatch;
export type IRootState = ReturnType<typeof store.getState>;
export type IAppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    IRootState,
    unknown,
    Action<string>
>;

export default store;
// The store now has redux-thunk added and the Redux DevTools Extension is turned on
